export const RIGHT_INFO_CONTENT = new Map([
  [
    "default",
    <>
      <p className="font-size-h2">Junte-se a mais de 150 mil advogados brasileiros! </p>
      <p className="font-size-h6">
        A tecnologia da Jusfy não substitui o seu talento: ela te dá superpoderes!

      </p>
      <p className="font-size-h6">
Transforme horas de trabalho burocrático em minutos com o ecossistema jurídico que alia inteligência artificial, gestão e soluções financeiras em um só lugar.
      </p>
      <p className="font-size-h6">
        E para garantir a sua tranquilidade, conte com nosso{" "}
        <span>suporte humanizado formado por especialistas na área jurídica.</span>
      </p>
      <p className="font-size-h6"><span>Transforme sua rotina agora!</span></p>
    </>,
  ],
  [
    "lawyersMonth",
    <>
      <p className="font-size-h2">Opa, tem cupom disponível pra você!</p>
      <p className="font-size-h6">
        <span>MESADVOGADO23</span> - aplique o cupom na etapa Finalizar Cadastro
        e tenha acesso ao <span>plano Master</span> de R$97,00 por apenas
        <span> R$19,90 nos três primeiros meses</span>.
      </p>
      <p className="font-size-h6">
        Com a aplicação do cupom, a cobrança de R$19,90 referente a mensalidade
        do plano é imediata.
      </p>
      <p className="font-size-h6">
        É a oportunidade perfeita para você conhecer a Jusfy!
      </p>
    </>,
  ],
  [
    "paymentLink",
    <>
    <p className="font-size-h2">Já ajudamos mais de 40 mil advogados</p>
    <p className="font-size-h6"><span>Mais segurança para você:</span> Validar seus dados garante que apenas você possa realizar pagamentos e movimentações com sua conta Jusfy.</p>
    <p className="font-size-h6"><span>Evite problemas futuros:</span> Com seus dados atualizados, conseguimos prevenir recusas no pagamento e facilitar o suporte caso algo aconteça.</p>
    <p className="font-size-h6"><span>Continue usando a Jusfy sem interrupções:</span> Essa validação rápida permite que você aproveite todos os recursos da plataforma sem imprevistos.</p>
    </>
  ]
]);
